<template>
    <headerSearch></headerSearch>
    <div class="w1440 personal_center">
        <div class="flex-box col90 ptb10 page_location">
            当前位置：<router-link class="col04" to="/">首页<span class="plr5">/</span></router-link>
            <div class="now_page">采购流程</div>
        </div>
        <div class="flex-box flex-col-start">
            <div class="flex-grow-1 part_r">
                <div class="fs16 col04" v-html="detail.content"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { useHead } from '@unhead/vue'
import { onMounted } from "vue"
export default {
    setup() {
        onMounted(() => {
            useHead({
                title: "采购流程-小狮优选",
                meta: [
                    { name: "description", content: "This is my page description" },
                    { property: "og:title", content: "My Page Title" },
                    { property: "og:description", content: "This is my page description" },
                    { property: "og:url", content: "https://example.com/my-page" },
                    { property: "og:image", content: "https://example.com/my-image.jpg" },
                ],
                link: [{ rel: "canonical", href: "https://example.com/my-page" }],
            })
        })
    },
    data() {
        return {
            detail: {},
        };
    },
    created() {
        this.getDetail();
    },
    methods: {
        getDetail() {
            this.$api.getPurchaseAgreement().then(res => {
                this.detail = res.data;
            }).catch(err => {
                console.log(err);
            })
        }
    },
};
</script>

<style lang="less" scoped>
.part_r {
    padding: 44px;
    background-color: #fff;

    .title_box {
        padding: 41px 0 32px;
        border-bottom: 1px solid rgba(98, 134, 171, 0.4);
        margin-bottom: 24px;
    }

    .item {
        height: 68px;
        background: #F7FAFF;
        padding: 0 44px 0 24px;

        .index {
            width: 44px;
            height: 44px;
            background: #FFFFFF;
            text-align: center;
            line-height: 44px;
            border-radius: 50%;
            margin-right: 15px;
        }

    }
}
</style>
